import React from "react";
import { FooterWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Box, LazyImage, SpanStyled } from "../../styled/Elements";
import { WhiteLogo } from "../../styled/AllImages";
import { footerNavs, socialIcon } from "../../data/data";
import { Link as ScrollLink } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";

const SearchProfileFooter = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const date_year = new Date();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (to) => {
    if (location.pathname === "/") {
      // Already on landing page; scroll with react-scroll
      return;
    }
    // Navigate to landing with scroll target
    navigate(`/?scrollTo=${to}`);
  };

  return (
    <FooterWrapper id="home" className="container-fluid footerWrapper" lang={language}>
      <Box className="footerCrWrapper">
        <Container className="footerContain2">
          <Row className="footer-row">
            <Box className="logoNavsWrapper">
              <Box className="footerLogo mt-2">
                <LazyImage src={WhiteLogo} />
              </Box>
              <Box className="text-center copyright mt-2">
                <Box className="footerLink">
                  {footerNavs.map((item, key) => (
                    <Box key={key}>
                      {location.pathname === "/" ? (
                        <ScrollLink
                          style={{ color: "var(--white)", cursor: "pointer" }}
                          to={item.to}
                          spy={true}
                          smooth={true}
                          offset={-60}
                          duration={500}
                        >
                          {t(item.label)}
                        </ScrollLink>
                      ) : (
                        <span
                          style={{ color: "var(--white)", cursor: "pointer" }}
                          onClick={() => handleNavClick(item.to)}
                        >
                          {t(item.label)}
                        </span>
                      )}
                    </Box>
                  ))}
                </Box>

                <Box className="footerCopyright">
                  <SpanStyled
                    className="footer-op"
                    size="14px"
                    color="var(--white)"
                    transform="capitalize"
                  >
                    &copy; {date_year.getFullYear()}
                    <SpanStyled
                      className="footer-op footer-op-company"
                      size="14px"
                      color="var(--white)"
                    >
                      {" "}
                      {t("falhub")}.
                    </SpanStyled>
                  </SpanStyled>
                  <SpanStyled
                    className="footer-op footer-op-allRights"
                    size="14px"
                    color="var(--white)"
                    transform="capitalize"
                  >
                    {" "}
                    {t("AllRightReserved2")}.
                  </SpanStyled>
                </Box>
              </Box>
            </Box>

            <Row className="d-flex mt-2 gap-2">
              {socialIcon.map((list, key) => (
                <Col
                  className="contact-links"
                  key={key}
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                  <a href={list.link} target="_blank" rel="noopener noreferrer">
                    <div className="social-icon d-flex justify-content-center align-items-center">
                      {list.img}
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
          </Row>
        </Container>
      </Box>
    </FooterWrapper>
  );
};

export default SearchProfileFooter;
